<script setup lang="ts">
import { computed } from 'vue';
import { AkIcon, AkTooltipInformation, AkButton, AkParagraph } from '@ankorstore/design-system';
import { getLang } from '@core/utilities/lang';
import { PROVEN_SUCCESS_FAQ_URL } from '@bc/discovery/ui/filters/constants';

withDefaults(
  defineProps<{
    tooltipPosition?: 'top' | 'right' | 'bottom' | 'left';
  }>(),
  {
    tooltipPosition: 'right',
  }
);

defineOptions({
  inheritAttrs: false,
});

defineEmits(['infoCtaClicked']);

const faqLink = computed(() => PROVEN_SUCCESS_FAQ_URL[getLang()]);
</script>

<template>
  <AkTooltipInformation
    class="proven-success-tooltip"
    :placement="tooltipPosition"
    trigger="hover"
    type="invert"
    custom-class="proven-success"
  >
    <slot>
      <AkIcon
        symbol="info-circle"
        size="md"
        class="ds-ml-4"
      />
    </slot>
    <template #container>
      <AkIcon
        symbol="arrow-repeat-check"
        class="proven-success-tooltip__content-icon"
      />
      <AkHeading4 class="proven-success-tooltip__content-title">
        {{ $t('discovery.product.badges.proven-success') }}
      </AkHeading4>
      <AkParagraph
        size="sm"
        class="proven-success-tooltip__content-paragraph"
      >
        {{ $t('discovery.catalog.filters.proven-success.copy') }}
      </AkParagraph>
      <a
        :href="faqLink"
        target="_blank"
      >
        <AkButton
          class="proven-success-tooltip__link"
          color="white"
          @click="$emit('infoCtaClicked')"
        >
          {{ $t('discovery.catalog.filters.proven-success.link') }}
        </AkButton>
      </a>
    </template>
  </AkTooltipInformation>
</template>

<style scoped lang="scss">
.proven-success-tooltip {
  display: inline-block;

  &__badge {
    margin-right: 0.5rem;
  }

  &__content-icon.icon--sm {
    position: absolute;
    line-height: 2;
  }

  &__content-title {
    font-size: theme('fontSize.sm');
  }

  &__content-title,
  &__content-paragraph {
    padding-left: 1.25rem;
  }

  &__link {
    margin: 0.75rem 0 0 1.25rem;
  }
}
</style>

<style lang="scss">
.ak-tooltip.ak-tooltip--proven-success .v-popper__inner {
  max-width: 275px;
}
</style>
